const AUCTION_STATES = {
  ACTIVE: "Active",
  EXPIRED: "Expired",
  SOLD: "Sold",
};

export default AUCTION_STATES;
